import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCountryInfo, getCurrencySymbol } from '../lib/currenyUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getInitialsName } from '../lib/utils';
import { encryptPayload } from '../utils/encryption';

function SendMoneyPaymentConfirmation() {
  const fileInputRef = useRef(null);

  const handleFileUpload = () => {
    fileInputRef.current.click();
  };

  const navigate = useNavigate();
  const location = useLocation();
  const paramsdata = location.state;
  const name = paramsdata.name;
  const ifsc = paramsdata.ifsc;
  const account = paramsdata.account;
  const type = paramsdata.type;
  const SendMoney_node = paramsdata.Node;
  const id = paramsdata.id;
  const bank_account_name = paramsdata.bank_account_name;
  const currencyid = paramsdata.currencyid;
  const contactId = paramsdata.contactId;
  const currency = paramsdata.currency;
  const amount = paramsdata.amount;
  const bank_account_id = paramsdata.bank_account_id;
  const country = paramsdata.country;
  const bene_type = paramsdata.bene_type;
  const bank_type = paramsdata.bank_type;
  const from_amount = paramsdata.from_amount;
  const from_currency = paramsdata.from_currency;
  const beneaddress = paramsdata?.address;

  const [, setDefaultBank] = useState('');
  const [transferReason, settransferReason] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const [transferReasons, setTransferReasons] = useState([]);
  const [ref, setRef] = useState('');
  const [notes, setNotes] = useState();
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState('');
  const [clearBankBalance] = useState(0.0);
  const [currencyCloudBalance] = useState(0.0);
  const [, setTransactionFees] = useState();
  const [userType, setUserType] = useState();
  const [showUploadedFiles, setShowUploadedFiles] = useState(false);

  const exchangeRate = location.state?.exchangeRate;

  const setReasonForTransfer = async (val) => {
    settransferReason(val);
  };

  useEffect(() => {
    setAsyncData();
    loadBalances();
  }, []);

  const setAsyncData = async () => {
    sessionStorage.setItem('beneficiary_id', JSON.stringify(id));
    sessionStorage.setItem('beneficiary_bank_account_name', bank_account_name);
    setDefaultBank(sessionStorage.getItem('defaultBank'));
    setTransferReasons(JSON.parse(sessionStorage.getItem('transfer_reasons')));
  };

  const loadBalances = async () => {
    setButtonLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const token = sessionStorage.getItem('login_token');
    const workspace = sessionStorage.getItem('login_workspaces');
    const parsedWorkspace = JSON.parse(workspace);
    setUserType(parsedWorkspace[0].type);
    var balanceUrl =
      Constants.BASE_URL +
      'API-FX-231-GET-WALLET-BALANCES/' +
      login_workspaces_id +
      '?currency=' +
      currency;
    const resp = await axios.get(balanceUrl, {
      headers: {
        Authorization: 'Bearer ' + JSON.parse(token),
        fx_key: Constants.SUBSCRIPTION_KEY,
      },
    });
    var transactionFee = 0;
    transactionFee =
      Object.prototype.hasOwnProperty.call(
        resp.data.fees_configuration,
        'transaction_fees',
      ) && resp.data.fees_configuration.transaction_fees.percentage;
    setTransactionFees(transactionFee);
    setButtonLoading(false);
  };

  const initiateWalletTransaction = async () => {
    setButtonLoading(true);
    sessionStorage.removeItem('transfer_reason');
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const token = sessionStorage.getItem('login_token');
    const workspace = sessionStorage.getItem('login_workspaces');
    const parsedWorkspace = JSON.parse(workspace);
    const login_full_name = parsedWorkspace[0].name;
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    if (transferReason != null && transferReason != '') {
      const encryptedPayload = await encryptPayload({
            contact_id: contactId,
            workspace_id: login_workspaces_id,
            reason_code: transferReason,
            full_name: bank_account_name,
            sort_code: ifsc,
            createTransaction: true,
            currency: currency,
            account_number: account,
            type: 'local',
            currency_cloud_balance: currencyCloudBalance,
            clear_bank_balance: clearBankBalance,
            total_balance: 0,
            beneficiaryId: id,
            reference: ref != '' ? ref : login_full_name,
            reason: transferReason,
            staff_login_id: staff_login_id,
            status: 'waiting for funds',
            flow: 'sendFlow',
            platform: 'web',extraParamValidation: 'trustedfromweb'
          });
      await axios
        .post(
          Constants.BASE_URL + 'API-FX-240-SEND-FLOW',
          encryptedPayload
          ,
          {
            headers: {
              fx_key: Constants.SUBSCRIPTION_KEY,
              Authorization: 'Bearer ' + JSON.parse(token),
            },
          },
        )
        .then((resp) => {
          const transactionId = resp?.data?.data?.id;
          if (file != '' && file != null) {
            handleSubmit(transactionId);
          }
          navigate('/payment-method', {
            state: {
              name, ifsc, account, type, id,
              exchangeRate,
              bank_account_name, currencyid, currency, amount,
              bank_account_id, country, bene_type, bank_type,
              contactId: paramsdata.contactId,
              from_currency, from_amount,
              transactionId,
            },
          });
        })
        .catch((err) => {
          const errorMessage =
            err.response?.data?.message ||
            err.message ||
            'Something went wrong. Please try again.';
          toast.error(errorMessage);
          setButtonLoading(false);
        });
    } else {
      toast.error('Please select transfer reason');
      setButtonLoading(false);
    }
  };

  const handleSingleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile?.name || '');
  };

  const getBase64 = async (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () { cb(reader.result); };
    reader.onerror = function (error) { console.log('Error: ', error); };
  };

  function handleSubmit(transactionId) {
    getBase64(file, (result) => { uploadSingleDocument(result, transactionId); });
  }

  const uploadSingleDocument = async (document, transactionId) => {
    if (notes != '' && notes != null && (file == '' || file == null))
      toast.error('File upload is mandatory');
    if (file != '' && file != null) {
      const token = sessionStorage.getItem('login_token');
      var extension = file.name.split('.');
      await axios
        .post(
          Constants.BASE_URL + 'API-FX-195-UPLOAD-USER-TRANSACTION-DOCUMENTS',
          {
            document,
            transaction_id: transactionId,
            notes: notes == '' || notes == null ? 'NA' : notes,
            extension: extension[extension.length - 1],
          },
          {
            headers: {
              Authorization: 'Bearer ' + JSON.parse(token),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        )
        .then((response) => { console.log(response.data); })
        .catch((err) => { err; });
    }
  };

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return (
    <div style={styles.pageWrapper}>
      <ToastContainer />

      {/* Page Title */}
      <div style={styles.pageTitleSection}>
        <h1 style={styles.pageTitle}>Account Review</h1>
        <p style={styles.pageSubtitle}>Review of sending details</p>
      </div>

      {/* Back Button */}
      <div style={styles.backRow}>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 5l-7 7 7 7" />
          </svg>
          <b>Back</b>
        </button>
      </div>

      {/* Main Card */}
      <div style={styles.card}>

        {/* Beneficiary Header */}
        <div style={styles.beneficiaryRow}>
          <div style={styles.avatarCircle}>
            {getInitialsName(name)}
          </div>
          <div style={styles.beneficiaryInfo}>
            <div style={styles.beneficiaryNameRow}>
              <span style={styles.beneficiaryName}>{name}</span>
              <span style={{ marginLeft: 4, fontSize: 16 }}>
                {getCountryInfo(currency, { className: 'w-5 h-5' }).flag}
              </span>
            </div>
            <p style={styles.beneficiaryAccount}>
              {account} ({ifsc})
            </p>
          </div>
        </div>

        {/* Account Details Box */}
        <div style={styles.detailsBox}>
          <p style={styles.detailsBoxTitle}>Account Details</p>
          <table style={styles.detailsTable}>
            <tbody>
              <tr style={styles.detailRow}>
                <td style={styles.detailLabel}>Account Number</td>
                <td style={styles.detailValue}>{account}({ifsc})</td>
              </tr>
              <tr style={styles.detailRow}>
                <td style={styles.detailLabel}>From Amount</td>
                <td style={styles.detailValue}>
                  {getCurrencySymbol(from_currency)} {numberWithCommas(from_amount)}.00
                </td>
              </tr>
              <tr style={styles.detailRow}>
                <td style={styles.detailLabel}>To Amount</td>
                <td style={styles.detailValue}>
                  {getCurrencySymbol(currency)} {numberWithCommas(amount)}
                </td>
              </tr>
              <tr style={styles.detailRow}>
                <td style={styles.detailLabel}>Type</td>
                <td style={styles.detailValue}>{type}</td>
              </tr>
              <tr style={styles.detailRow}>
                <td style={styles.detailLabel}>Country</td>
                <td style={styles.detailValue}>{country}</td>
              </tr>
              {beneaddress && (
                <tr style={styles.detailRow}>
                  <td style={styles.detailLabel}>Address</td>
                  <td style={styles.detailValue}>{beneaddress}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Transfer Reason Select */}
        <div style={styles.inputGroup}>
          {currency != 'INR' ? (
            <select
              onChange={(e) => setReasonForTransfer(e.target.value)}
              value={transferReason}
              style={styles.selectInput}
            >
              <option value="">Select Transfer Reason</option>
              {transferReasons.map((option) => (
                <option key={option.id} value={option.reason}>
                  {option.reason}
                </option>
              ))}
            </select>
          ) : (
            <select
              onChange={(e) => setReasonForTransfer(e.target.value)}
              value={transferReason}
              style={styles.selectInput}
            >
              <option value="">Select Transfer Reason</option>
              {userType == 'individual'
                ? Constants.INR_INDIVIDUAL_REASONS.map((option) => (
                    <option key={option.id} value={option.code + '_' + option.display_name}>
                      {option.display_name}
                    </option>
                  ))
                : Constants.INR_BUSINESS_REASONS.map((option) => (
                    <option key={option.id} value={option.code + '_' + option.display_name}>
                      {option.display_name}
                    </option>
                  ))}
            </select>
          )}
        </div>

        {/* Payment Reference */}
        <div style={styles.inputGroup}>
          <input
            type="text"
            value={ref}
            onChange={(e) => setRef(e.target.value)}
            placeholder="Enter Payment Reference(Optional)"
            maxLength={35}
            style={styles.textInput}
          />
        </div>

        {/* Notes */}
        {SendMoney_node !== 'node_2' && (
          <div style={styles.inputGroup}>
            <input
              type="text"
              placeholder="Enter Your Notes"
              onChange={(e) => setNotes(e.target.value)}
              style={styles.textInput}
            />
          </div>
        )}

        {/* Upload Documents */}
        <div style={styles.uploadSection}>
          <div style={styles.uploadCenter}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="16 16 12 12 8 16" />
              <line x1="12" y1="12" x2="12" y2="21" />
              <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
            </svg>
            <span style={styles.uploadLink} onClick={handleFileUpload}>
              Upload Documents
            </span>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={(event) => handleSingleFileChange(event)}
            />
            {fileName && (
              <button
                style={styles.viewBtn}
                onClick={() => setShowUploadedFiles(!showUploadedFiles)}
              >
                View {showUploadedFiles ? '▲' : '▼'}
              </button>
            )}
          </div>
          <p style={styles.uploadHint}>Supported Format :&nbsp;&nbsp;JPG,PNG or PDF - (Max 50MB)</p>
          {showUploadedFiles && fileName && (
            <div style={styles.uploadedFileTag}>
              📎 {fileName}
            </div>
          )}
        </div>

        {/* Continue Button */}
        <div style={styles.btnWrapper}>
          <button
            onClick={!buttonLoading ? initiateWalletTransaction : undefined}
            style={{
              ...styles.confirmBtn,
              opacity: buttonLoading ? 0.8 : 1,
              cursor: buttonLoading ? 'not-allowed' : 'pointer',
            }}
          >
            {buttonLoading ? 'Processing...' : 'Continue'}
            {!buttonLoading && (
              <svg style={{ marginLeft: 8 }} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            )}
          </button>
        </div>

        {/* Security Badge */}
        <div style={styles.securityBadge}>
          <div style={styles.securityIcon}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C0392B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <div>
            <p style={styles.securityTitle}>100% Secure &amp; Safe</p>
            <p style={styles.securityText}>
              Your money is protected with bank-level encryption. We never store your banking credentials.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}

const styles = {
  pageWrapper: {
    minHeight: '100vh',
    backgroundColor: '#F0F2F5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '28px 16px 48px',
    fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  pageTitleSection: {
    textAlign: 'center',
    marginBottom: 10,
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: '#1A202C',
    margin: 0,
    letterSpacing: '-0.2px',
  },
  pageSubtitle: {
    fontSize: 13,
    color: '#8A93A8',
    margin: '3px 0 0',
  },
  backRow: {
    width: '100%',
    maxWidth: 500,
    marginBottom: 12,
  },
  backBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    background: 'none',
    border: 'none',
    color: '#4A5568',
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    padding: '4px 0',
  },
  card: {
    width: '100%',
    maxWidth: 500,
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
    padding: '20px 22px 22px',
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  },
  beneficiaryRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    paddingBottom: 2,
  },
  avatarCircle: {
    width: 42,
    height: 42,
    borderRadius: '50%',
    backgroundColor: '#D6E4F7',
    color: '#2C3E6B',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 15,
    flexShrink: 0,
  },
  beneficiaryInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  beneficiaryNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  beneficiaryName: {
    fontSize: 15,
    fontWeight: 700,
    color: '#1A202C',
  },
  beneficiaryAccount: {
    fontSize: 13,
    color: '#6B7280',
    margin: 0,
  },
  detailsBox: {
    border: '1px solid #E8ECF0',
    borderRadius: 9,
    padding: '13px 16px',
    backgroundColor: '#FAFBFC',
  },
  detailsBoxTitle: {
    fontSize: 11,
    fontWeight: 600,
    color: '#2C3E6B',
    margin: '0 0 10px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  detailsTable: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  detailRow: {
    borderBottom: '1px solid #F0F2F5',
  },
  detailLabel: {
    padding: '7px 0',
    fontSize: 13,
    color: '#6B7280',
    fontWeight: 400,
    width: '42%',
  },
  detailValue: {
    padding: '7px 0',
    fontSize: 13,
    color: '#1A202C',
    fontWeight: 600,
  },
  inputGroup: {
    width: '100%',
  },
  selectInput: {
    width: '100%',
    padding: '11px 13px',
    borderRadius: 8,
    border: '1px solid #E2E8F0',
    backgroundColor: '#FFFFFF',
    fontSize: 14,
    color: '#4A5568',
    outline: 'none',
    cursor: 'pointer',
    appearance: 'auto',
  },
  textInput: {
    width: '100%',
    padding: '11px 13px',
    borderRadius: 8,
    border: '1px solid #E2E8F0',
    backgroundColor: '#F8FAFC',
    fontSize: 14,
    color: '#1A202C',
    outline: 'none',
    boxSizing: 'border-box',
  },
  uploadSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    alignItems: 'center',
  },
  uploadCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
  },
  uploadLink: {
    color: '#3B82F6',
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  },
  uploadHint: {
    fontSize: 12,
    color: '#9CA3AF',
    margin: 0,
    textAlign: 'center',
  },
  viewBtn: {
    background: 'none',
    border: 'none',
    color: '#4A5568',
    fontSize: 13,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontWeight: 500,
  },
  uploadedFileTag: {
    fontSize: 12,
    color: '#4A5568',
    backgroundColor: '#F0F4FF',
    borderRadius: 6,
    padding: '6px 10px',
  },
  btnWrapper: {
    marginTop: 2,
  },
  confirmBtn: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#E8650A',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    letterSpacing: '0.2px',
    transition: 'background 0.2s',
  },
  securityBadge: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 11,
    backgroundColor: '#FFF5F4',
    border: '1px solid #FDDBD8',
    borderRadius: 10,
    padding: '13px 15px',
  },
  securityIcon: {
    flexShrink: 0,
    marginTop: 2,
  },
  securityTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: '#1A202C',
    margin: '0 0 3px',
  },
  securityText: {
    fontSize: 12,
    color: '#6B7280',
    margin: 0,
    lineHeight: 1.5,
  },
};

export default SendMoneyPaymentConfirmation;
